import template from './positionSearchForm.html';
import controller from './positionSearchForm.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    staffUser: '<',
    onDismiss: '&',
  }
};

export default component;
